import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export function ImpersonationBanner() {
  const { impersonation, stopImpersonation } = useAuth();
  const navigate = useNavigate();

  if (!impersonation.active) return null;

  const handleExit = async () => {
    await stopImpersonation();
    navigate('/admin');
  };

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-orange-500 text-white px-4 py-2 flex items-center justify-between shadow-md">
      <span className="text-sm font-medium">
        🔍 Admin view: You are viewing as{' '}
        <strong>{impersonation.clientName}</strong>
      </span>
      <button
        onClick={handleExit}
        className="text-sm font-semibold bg-white text-orange-600 px-3 py-1 rounded-lg hover:bg-orange-50 transition-colors"
      >
        Exit Admin View
      </button>
    </div>
  );
}
